<template>

    <div class="collapser" :class="{'collapser-close' : isClose}">
        <div class="collapser_content">
            <slot></slot>
        </div>
        <ButtonMagnetic v-if="!noCollapse" @click.native="open" :minus="!isClose"></ButtonMagnetic>
    </div>

</template>

<script>
    import ButtonMagnetic from "./ButtonMagnetic";
    export default {
        name: 'Collapser',
        components: {ButtonMagnetic},
        props: ['noCollapse'],
        data: function(){
            return {
                isClose: true,
            };
        },
        mounted: function(){

            // si jamais on veut, on peut annuler le collapser (ouvert par default et sans bouton)
            if(this.noCollapse){
                this.isClose = false;
            }
        },
        methods: {
            open: function(){
                this.isClose = (!this.isClose);
            }
        }
    };
</script>

<style scoped lang="scss">
    .collapser{

        &_content{
            overflow: hidden;
            max-height: 1000px;
            @include transition();

            > div {
                padding-bottom: 1rem;
            }
        }
        &-close{
            .collapser_content{
                max-height: 100px;
            }
        }
        &:after{
            content: '';
            clear: both;
            display: block;
        }
    }

    .buttonMagnetic{
        float: right;
        margin: $G-default/2 0;
    }
</style>